import { Injectable } from '@angular/core';
import { User } from './user.service';

interface UserSessionData {
  user: User
  token: string
  refreshToken: string
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor() { }

  public get currentUserValue(): UserSessionData {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  public get isAuthenticated() {
    return !!this.currentUserValue;
  }

  public get userHasEmailFromTriider() {
    const currentUser = this.currentUserValue?.user

    if (!currentUser) return null

    const userHasEmailFromTriider = currentUser.email.includes('@triider.com')

    return userHasEmailFromTriider
  }

  setSession(data: UserSessionData) {
    data.user.profile_picture = data.user.profile_picture || "https://icon-library.net/images/default-user-icon/default-user-icon-8.jpg";
    localStorage.setItem('currentUser', JSON.stringify({
      user: data.user,
      token: data.token,
      refreshToken: data.refreshToken
    }));
  }

  removeSession() {
    localStorage.removeItem('currentUser');
  }
}
